import { SpCard } from '../sp-card';

export function SpXCard(props) {
  const { children, style, ...cardProps } = props;
  const bodyStyle = { ...cardProps.bodyStyle, backgroundColor: '#1C2536' };

  return (
    <SpCard
      {...cardProps}
      style={{ border: '1px solid #000', overflow: 'hidden', marginBottom: 0, ...style }}
      bodyStyle={bodyStyle}
      headStyle={{ backgroundColor: '#10151d' }}
    >
      {children}
    </SpCard>
  );
}
